import ActividadTile from './ActividadTile';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaQrcode, FaTicketAlt, FaUserFriends } from 'react-icons/fa';
import { RoleLayout, RoleGrid, RoleTile } from './RoleShell';

export default function Organizador() {
  const navigate = useNavigate();

  return (
    <RoleLayout
      title="Panel — Organizador"
      subtitle="Gestiona únicamente las invitaciones, entradas y escáner de los eventos que tienes asignados."
      roleLabel="Rol: Organizador"
    >
      <RoleGrid>
        <ActividadTile/>
        <RoleTile
          icon={FaUserFriends}
          label="Generar invitaciones"
          description="Crea invitaciones QR para tus eventos asignados."
          onClick={() => navigate('/dashboard/invitaciones')}
        />

        <RoleTile
          icon={FaUserFriends}
          label="Administrar invitaciones"
          description="Revisa invitaciones generadas en modo solo lectura."
          onClick={() => navigate('/admin/invitaciones')}
        />

        <RoleTile
          icon={FaTicketAlt}
          label="Generar entradas"
          description="Crea entradas QR para venta o control de acceso."
          onClick={() => navigate('/entradas')}
        />

        <RoleTile
          icon={FaTicketAlt}
          label="Administrar entradas"
          description="Revisa y filtra entradas en modo solo lectura."
          onClick={() => navigate('/entradas/admin')}
        />

        <RoleTile
          icon={FaQrcode}
          label="Escanear entradas"
          description="Valida entradas pagadas y controla el ingreso."
          onClick={() => navigate('/entradas/escanear')}
        />

        <RoleTile
          icon={FaQrcode}
          label="Escanear invitaciones"
          description="Escanea y valida invitaciones de tus eventos."
          onClick={() => navigate('/escanear')}
        />
      </RoleGrid>
    </RoleLayout>
  );
}